import React from 'react'

interface UpdateIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const UpdateIcon: React.FC<UpdateIconProps> = ({
  color = '#000',
  gradient = false,
  width = 26,
  height = 26,
  alt = 'Update icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 26 26'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M23.107.802a.625.625 0 00-1.035-.244l-1.908 1.908a12.75 12.75 0 00-6.982-2.07C6.109.396.375 6.13.375 13.203c0 .615.043 1.22.127 1.811a.625.625 0 001.238-.175 11.66 11.66 0 01-.115-1.636c0-6.382 5.174-11.557 11.557-11.557a11.5 11.5 0 016.077 1.725l-1.494 1.494A.625.625 0 0018.01 5.9l6.46 2.153a.625.625 0 00.791-.79L23.107.803zm-2.43 2.92l-1.313 1.312 4.315 1.438-1.438-4.315-1.554 1.554a.546.546 0 01-.01.01zm4.779 7.264a.625.625 0 10-1.238.175c.076.534.115 1.08.115 1.636 0 6.382-5.174 11.556-11.557 11.556A11.5 11.5 0 016.7 22.63l1.493-1.494a.625.625 0 00-.244-1.034l-6.46-2.154a.625.625 0 00-.79.79l2.153 6.461a.625.625 0 001.034.244l1.908-1.907a12.75 12.75 0 006.982 2.069c7.073 0 12.807-5.734 12.807-12.807a12.9 12.9 0 00-.127-1.811zm-18.862 9.98l-1.297 1.298a.634.634 0 00-.04.04l-1.54 1.54-1.438-4.316 4.315 1.439z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default UpdateIcon
